import { FilterGroupsControl } from 'spark-core-dx/components';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';
import { createDefaultFilterDraft, normalizeDashboardQueryState } from '../../../visualQueryStateUtils';
import './Filter.scss';

export const Filter = ({ selectedColumns = [] }) => {
    const { visualObject, setVisualObject } = useVisualFormContext();
    const filterableColumns = (selectedColumns ?? []).filter((column) => column?.CanFilter !== false);
    const filters =
        Array.isArray(visualObject?.DefaultQueryState?.FilterDraft) &&
        visualObject.DefaultQueryState.FilterDraft.length > 0
            ? visualObject.DefaultQueryState.FilterDraft
            : createDefaultFilterDraft();

    if (filterableColumns.length === 0) {
        return (
            <div className="dialog-description">
                Select a model first to configure visual filters.
            </div>
        );
    }

    return (
        <FilterGroupsControl
            filterables={filterableColumns}
            filters={filters}
            onChange={(nextFilters) => {
                setVisualObject((prev) => ({
                    ...prev,
                    DefaultQueryState: normalizeDashboardQueryState(prev?.DefaultQueryState, {
                        ModelKind: Number(prev?.ModelKind ?? 0),
                        ModelId: prev?.ModelId ?? '',
                        FilterDraft: nextFilters,
                    }),
                }));
            }}
        />
    );
};
